import { Dispatch } from 'redux';
import { axiosInstance, request, requestConfig } from './base';
import { AtualizarCoordenadoresRequest, DelimitacaoCoordenadorResponse, DistribuirLoteRequest, PostInstrumentosCoordenadoresRequest } from 'common/genericTypes';

export const PUTDistribuirLote = async (
  dispatch: Dispatch,
  instrumentoGuId: string,
  distribuirLoteRequest: DistribuirLoteRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.put(
        `${requestConfig.api}api/v1/coordenadores/${instrumentoGuId}`,
        distribuirLoteRequest
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTInstrumentosCoordenadores = async (
  dispatch: Dispatch,
  filter: PostInstrumentosCoordenadoresRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post(
        `${requestConfig.api}api/v1/coordenadores`,
        filter
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETQuantidadeDelimitadaPorCoordenador = async (
  dispatch: Dispatch,
  instrumentoFinanceiroGuid: string,
  stackRequest: boolean = false
): Promise<Array<DelimitacaoCoordenadorResponse>> => {
  return await request(
    () =>
      axiosInstance.get<Array<DelimitacaoCoordenadorResponse>>(
        `${requestConfig.api}api/v1/coordenadores/delimitacao/${instrumentoFinanceiroGuid}/quantidade`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTAtualizarCoordenadoresCompleto = async (
  dispatch: Dispatch,
  instrumentoFinanceiroCodigo: string,
  atualizarCoordenadoresRequest: AtualizarCoordenadoresRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.put(
        `${requestConfig.api}api/v1/coordenadores/${instrumentoFinanceiroCodigo}/completo`,
        atualizarCoordenadoresRequest
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTExportarMapaAlocacao = async (
  dispatch: Dispatch,
  filter: PostInstrumentosCoordenadoresRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post(
        `${requestConfig.api}api/v1/coordenadores/mapa-alocacao-html`,
        filter
      ),
    dispatch,
    undefined,
    stackRequest
  );
};